import React from 'react';
import { Navbar, Nav, Container } from 'react-bootstrap';
import techMonolithLogo from '../assets/images/techmonolith.svg';

const Navigation = ({ texts, scrollToSection, toggleLanguage, homeRef, featuresRef, contactRef }) => {
    return (
        <Navbar bg="dark" variant="dark" expand="lg" sticky="top">
            <Container>
                <Navbar.Brand href="https://techmonolith.com" target="_blank" rel="noopener noreferrer">
                    <img src={techMonolithLogo} alt={texts.navbar.brand} className="logo" />
                </Navbar.Brand>
                <Navbar.Toggle aria-controls="basic-navbar-nav" />
                <Navbar.Collapse id="basic-navbar-nav">
                    <Nav className="ms-auto">
                        <Nav.Link onClick={() => scrollToSection(homeRef)}>{texts.navbar.home}</Nav.Link>
                        <Nav.Link onClick={() => scrollToSection(featuresRef)}>{texts.navbar.features}</Nav.Link>
                        <Nav.Link onClick={() => scrollToSection(contactRef)}>{texts.navbar.contact}</Nav.Link>
                        <Nav.Link onClick={toggleLanguage} className="language-toggle">{texts.navbar.language}</Nav.Link>
                    </Nav>
                </Navbar.Collapse>
            </Container>
        </Navbar>
    );
};

export default Navigation;
